// extracted by mini-css-extract-plugin
export default {"loader":"map_loader__BhVza","rotate":"map_rotate__eTpO2"};